import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { PageSubmitButton } from 'Views/Page/Components/PageSubmitButton/PageSubmitButton';
import { FDContentContainer, FDStack } from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  LayoutPaperActions,
  WizardLayout,
} from 'Views/Page/Content/Templates/WizardTemplates/EstatePlanningRecommendation/Components';

const useStyles = buildUseStyles('QuestionStepLayout', (theme) => ({
  content: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    overflow: 'hidden', // This is needed to make the FAQ sticky
    '& > .FD-MuiContainer-root': {
      overflowY: 'auto',
    },
    rowGap: theme.spacing(8),
    justifyContent: 'center',
    paddingBottom: theme.spacing(8),
  },
}));

export const Layout = () => {
  const { pageContentResource } = usePageContentContext();
  useBoneBackgroundColor();
  const classes = useStyles();

  return (
    <WizardLayout>
      <div className={classes.content}>
        <FDContentContainer maxWidth={'md'}>
          <FDStack direction={'column'} spacing={4}>
            <MetaControlField attr={'questions'} />
            <LayoutPaperActions>
              <PageSubmitButton resource={pageContentResource} />
            </LayoutPaperActions>
          </FDStack>
        </FDContentContainer>
        <MetaControlField attr={'frequentlyAskedQuestions'} />
      </div>
    </WizardLayout>
  );
};
